import { styled } from "@mui/material/styles";

export const HeaderButton = styled("button")({
  display: "inline-flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "11px",
  flex: 1,
  padding: "8px 4px",
  borderRadius: "6px",
  border: "1px solid rgba(0,0,0,0.2)",
  background: "white",
  cursor: "pointer",
  color: "rgba(0,0,0,0.7)",
  gap: "6px",
  "& svg": { fontSize: 18 },
  "&:hover": {
    background: "rgba(25,118,210,0.06)",
    borderColor: "#1976d2",
    color: "#1976d2",
  },
  "&:focus-visible": {
    outline: "2px solid #1976d2",
    outlineOffset: "2px",
  },
});

export const HeaderButtonText = styled("span")({
  fontSize: "12px",
  lineHeight: 1,
});

export const DisabledHeaderButton = styled(HeaderButton)({
  background: "transparent",
  border: "1px solid transparent",
  cursor: "default",
  color: "rgba(0,0,0,0.4)",
  boxShadow: "none",
  "&:hover": {
    background: "transparent",
    borderColor: "transparent",
    color: "rgba(0,0,0,0.4)",
  },
});
